import { LOGIN_NAVIGATION_MAP } from '../../../flows/login/components/LoginNavigation/constants';

export const MFA_STEPS_MAP = {
  LOADER: 0,
  INTRO: 1,
  RESEND: 2,
  TAKE_5: 3,
  TOOK_A_BREAK: 4,
};

export const BACK_BUTTON_STYLE = {
  CONTAINER: {
    CLASS_NAME: 'bg-bw02 h-screen m-screen content-center m-auto',
  },
  CLASS_NAME:
    'absolute top-0 left-0 mt-[3.75rem] ml-[3.75rem] w-[2.5rem] h-[2.5rem] border box-border border-solid rounded-md border-bw05 flex items-center justify-center',
  CTA_BUTTON: 'text-sm mt-4 w-full h-12',
};

export const RESEND_VERIFICATION_SCREEN_DATA = {
  HEADING: {
    TITLE: 'RESEND_VERIFICATION_CODE_PAGE_HEADER',
    CLASS_NAME: 'heading font-metricSemibold text-bw08 mb-2',
  },
  TEXT: {
    TITLE: 'RESEND_VERIFICATION_CODE_PAGE_TEXT',
    CLASS_NAME: 'font-metric text-base text-bw07 mb-4',
  },
  LOGIN_BTN: {
    CLASS_NAME: 'text-sm mt-4 text-bw00 bg-action03 w-full h-12 rounded font-metricBold hover:bg-action04',
  },
  ACTIONS: {
    SUCCESS: LOGIN_NAVIGATION_MAP.VERIFICATION_CODE,
    FAILURE: undefined,
    BACK: LOGIN_NAVIGATION_MAP.VERIFICATION_CODE,
  },
};

export const MFA_REDIRECT_ERRORS = {
  TOOK_A_BREAK: 40031,
  TAKE5: 40081,
  TAKE5_A: 4026,
};

export const MFA_RELATED_ERRORS = [
  40030, 40031, 40032, 40033, 40034, 40035, 40036, 40037, 40038, 40040, 40041, 40042, 40043, 40044, 40047, 40081,
  400481, 4039, 4026,
];

export const MFA_TEXTS = {
  INCORRECT_CODE: 'Invalid code',
  CUSTOM_CHECKBOX_TITLE: 'Remember multi-factor authentication on this device',
  BUTTON_TITLE_SMS: 'Text me',
  BUTTON_TITLE_VOICE: 'Call me',
  TITLE_SMS: 'Text Message (SMS)',
  TITLE_VOICE: 'Phone Call',
};

export const STYLES = {
  ERROR_TEXT: 'font-metricR text-red02 mb-4 text-[13px]',
};
